export default __webpack_public_path__ + "static/media/nodejs.aa8bc616.png";